/* vp-ugc.js -- TikTok/UGC social-proof grid for the Vegan Protein builder
   arm (claude-4). Loaded ONLY by that arm's template.

   POSITION: directly after the buy box (.vp-buy) and before the "clean by
   omission" panel (.vp-panel.vp-sky) -- the same placement Javvy use on
   /products/protein-refreshers, i.e. below the flavour selector rather than
   inside it.

   The order of .vp-wrap's children is:
       .vp-buy  ->  [THIS]  ->  .vp-panel.vp-sky  ->  .vp-sec  ->  ...

   ---- WHY POSTER IMAGES AND NOT EMBEDS OR <video> -------------------------
   Copied from how Javvy actually build theirs: each tile is a still image with
   a play button, and NOTHING video-related loads until the shopper clicks. I
   checked their page -- zero <video> elements and zero TikTok iframes until
   interaction.

   That matters more here than for them. This PDP already pulls from 66
   third-party hosts; four TikTok embeds would add four more origins plus their
   player JS. These MP4s are on Shopify's CDN and the posters are Shopify's own
   generated thumbnails, so this adds NO new origin at all.

   ---- WHY INJECTED RATHER THAN A LIQUID SECTION --------------------------
   .vp-buy and .vp-panel.vp-sky are both rendered by sections/vp-pdp-2.liquid,
   which claude-2 and claude-5 SHARE. A template-level section cannot be placed
   between two blocks that live inside another section -- it would render after
   the whole thing. Injecting is the only way to hit this spot without forking
   a 30KB section and a 55KB engine that two other arms depend on.

   ---- STYLING -------------------------------------------------------------
   The wrapper reuses the page's own .vp-sec and .vp-eyebrow classes, so its
   vertical rhythm and pill styling come from the existing stylesheet and
   cannot drift from the panels above and below it. Only the grid and tiles
   are new (see vp-ugc.css).

   ---- PLAYBACK ------------------------------------------------------------
   Clicking a tile swaps the poster for a <video controls autoplay playsinline>
   in place and pauses any other tile. playsinline matters on iOS: without it
   Safari goes fullscreen, which throws the shopper out of the page.

   The tile is a <div role="button">, not a <button> -- a real button would
   swallow clicks meant for the video's own controls once the video is mounted
   inside it. Role and tabindex are dropped after mount.

   To change the line-up, edit VIDEOS. `src` is the Shopify CDN mp4; `poster`
   is Shopify's generated thumbnail for that same file. */
(function(){
  "use strict";

  var EYEBROW = "as seen on tiktok";
  var HEADING = "see it in real life";

  var VIDEOS = [
    { src: "https://cdn.shopify.com/videos/c/o/v/7f3f6b821fd84f12884a3aadf03647d2.mp4",
      poster: "https://cdn.shopify.com/s/files/1/0090/0192/6735/files/preview_images/7f3f6b821fd84f12884a3aadf03647d2.thumbnail.0000000000.jpg?v=1789328749",
      handle: "@jenessa.gray" },
    { src: "https://cdn.shopify.com/videos/c/o/v/9bbab1403adb41a5ac83ad931c894858.mp4",
      poster: "https://cdn.shopify.com/s/files/1/0090/0192/6735/files/preview_images/9bbab1403adb41a5ac83ad931c894858.thumbnail.0000000000.jpg?v=1789328751",
      handle: "@sammies.bakes" },
    { src: "https://cdn.shopify.com/videos/c/o/v/703e6294cc4a44e49432d32c1cb2bb09.mp4",
      poster: "https://cdn.shopify.com/s/files/1/0090/0192/6735/files/preview_images/703e6294cc4a44e49432d32c1cb2bb09.thumbnail.0000000000.jpg?v=1789328872",
      handle: "@brandienicole27" },
    { src: "https://cdn.shopify.com/videos/c/o/v/f6374c19ae3e4b218b0b4e08f7b8e2be.mp4",
      poster: "https://cdn.shopify.com/s/files/1/0090/0192/6735/files/preview_images/f6374c19ae3e4b218b0b4e08f7b8e2be.thumbnail.0000000000.jpg?v=1789328888",
      handle: "@beamazing" }
  ];

  var PLAY_SVG = '<svg viewBox="0 0 44 44" width="100%" height="100%" aria-hidden="true">'
    + '<circle cx="22" cy="22" r="21" fill="rgba(255,255,255,.92)"/>'
    + '<path d="M18 14.5v15l12-7.5z" fill="#0d394e"/></svg>';

  function tile(v){
    var d = document.createElement("div");
    d.className = "vp-ugc-tile";
    d.setAttribute("role", "button");
    d.setAttribute("tabindex", "0");
    d.setAttribute("aria-label", "Play video from " + v.handle);
    d.setAttribute("data-src", v.src);
    /* width/height reserve the 9:16 box before the poster loads, so the panels
       below do not jump while the shopper is reading. */
    d.innerHTML = '<img src="' + v.poster + '" alt="" loading="lazy" decoding="async" width="1080" height="1920">'
      + '<span class="vp-ugc-play">' + PLAY_SVG + '</span>'
      + '<span class="vp-ugc-handle">' + v.handle + '</span>';
    return d;
  }

  function play(d){
    if(d.querySelector("video")) return;
    var vid = document.createElement("video");
    vid.src = d.getAttribute("data-src");
    vid.controls = true;
    vid.autoplay = true;
    vid.preload = "auto";
    vid.playsInline = true;
    vid.setAttribute("playsinline", "");    /* attribute form for older iOS */
    d.innerHTML = "";
    d.appendChild(vid);
    d.classList.add("is-playing");
    d.removeAttribute("role");
    d.removeAttribute("tabindex");
    d.removeAttribute("aria-label");
    /* one at a time -- four clips at once is noise, and on mobile it is four
       simultaneous downloads. */
    [].slice.call(document.querySelectorAll("#vpUgc video")).forEach(function(o){
      if(o !== vid){ try { o.pause(); } catch(e){} }
    });
    var p = vid.play();
    if(p && p.catch) p.catch(function(){ /* autoplay refused -- controls remain */ });
  }

  function mount(){
    if(document.getElementById("vpUgc")) return true;
    var buy = document.querySelector(".vp-wrap > .vp-buy");
    if(!buy) return false;

    var sec = document.createElement("section");
    sec.id = "vpUgc";
    sec.className = "vp-sec vp-ugc";

    var eye = document.createElement("span");
    eye.className = "vp-eyebrow";
    eye.textContent = EYEBROW;

    var h = document.createElement("h2");
    h.textContent = HEADING;

    var grid = document.createElement("div");
    grid.className = "vp-ugc-grid";
    VIDEOS.forEach(function(v){ grid.appendChild(tile(v)); });

    sec.appendChild(eye);
    sec.appendChild(h);
    sec.appendChild(grid);
    buy.parentNode.insertBefore(sec, buy.nextSibling);

    grid.addEventListener("click", function(e){
      var d = e.target.closest(".vp-ugc-tile");
      if(d && !d.classList.contains("is-playing")) play(d);
    });
    grid.addEventListener("keydown", function(e){
      if(e.key !== "Enter" && e.key !== " ") return;
      var d = e.target.closest(".vp-ugc-tile");
      if(d && !d.classList.contains("is-playing")){ e.preventDefault(); play(d); }
    });
    return true;
  }

  /* .vp-buy is server-rendered Liquid, so this normally lands on the first
     try; the observer is only a safety net, and disconnects once mounted. */
  var obs = new MutationObserver(function(){ if(mount()) obs.disconnect(); });

  function boot(){
    if(!mount()) obs.observe(document.body, { childList: true, subtree: true });
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  window.addEventListener("load", boot);
})();